import React from 'react';
import { Step1BasicInfo } from './Step1BasicInfo';
import { Step2Files } from './Step2Files';

import { Card } from 'primereact/card';

interface Step1InfoAndFilesProps {
    // Step 1 Props
    formData: any;
    setFormData: (data: any) => void;
    documentTypes: any[];
    isViewMode?: boolean;
    validationTriggered?: boolean;
    touchedFields?: Record<string, boolean>;
    markDirty?: () => void;
    
    // Step 2 Props
    mainFiles: any[];
    attachedFiles: any[];
    filePreviews: Record<string, string>;
    previewLoading: Record<string, boolean>;
    onComputerUpload: () => void;
    onCreateGoogleFile: () => void;
    onSelectTemplate?: () => void;
    onViewFile: (file: any) => void;
    onRemoveFile: (file: any) => void;
    onAttachmentUpload: () => void;
    getFileMenuItems: (file: any) => any[];
    getAttachmentMenuItems: (file: any) => any;
    getIconByExtension: (ext: string) => { icon: string; color: string };
    isTemplateMode?: boolean;
    onAutoLoadTemplate?: (templateId: string) => void;
    pdfGenerating?: Set<string>;
}


export const Step1InfoAndFiles: React.FC<Step1InfoAndFilesProps> = (props) => {
    return (
        <div className="grid mt-2 mx-auto" style={{ maxWidth: '1500px' }}>
            <div className="col-12 lg:col-8 order-2 lg:order-1">
                <Step2Files 
                    formData={props.formData}
                    mainFiles={props.mainFiles}
                    attachedFiles={props.attachedFiles}
                    isViewMode={props.isViewMode}
                    filePreviews={props.filePreviews}
                    previewLoading={props.previewLoading}
                    onComputerUpload={props.onComputerUpload}
                    onCreateGoogleFile={props.onCreateGoogleFile}
                    onSelectTemplate={props.onSelectTemplate}
                    onViewFile={props.onViewFile}
                    onRemoveFile={props.onRemoveFile}
                    onAttachmentUpload={props.onAttachmentUpload}
                    getFileMenuItems={props.getFileMenuItems}
                    getAttachmentMenuItems={props.getAttachmentMenuItems}
                    getIconByExtension={props.getIconByExtension}
                    isTemplateMode={props.isTemplateMode}
                    pdfGenerating={props.pdfGenerating}
                />
            </div>

            <div className="col-12 lg:col-4 order-1 lg:order-2">
                <Card
                    title={<span style={{ color: 'var(--text-color)', fontSize: '1.25rem', fontWeight: 'bold' }}>Thông tin tài liệu</span>}
                    className="h-full shadow-1 border-round-xl surface-100"
                    style={{ background: '#f0f2f5', minHeight: 520 }}
                >
                    <Step1BasicInfo
                        formData={props.formData}
                        setFormData={props.setFormData}
                        documentTypes={props.documentTypes}
                        isViewMode={props.isViewMode}
                        validationTriggered={props.validationTriggered}
                        touchedFields={props.touchedFields}
                        markDirty={props.markDirty}
                        isTemplateMode={props.isTemplateMode}
                        onAutoLoadTemplate={props.onAutoLoadTemplate}
                    />
                </Card>
            </div>
        </div>
    );
};
